<template>
    <b-row cols="1">
        <b-col>
            <vtk-button :href="downloadHref" />
        </b-col>
        <b-col>
            <hr />
        </b-col>
        <b-col>
            <!-- <vtk-viewer :vtk-files="vtkFiles" /> -->
            <b-button v-if="!start" variant="primary" class="mb-2" @click="startVisu">
                <i class="fa fa-play mr-2" />Iniciar visualização Geometry
            </b-button>
            <div style="max-height: 600px" class="d-flex border rounded">
                <vtk-geometry v-if="start" :objs="GeometryUrls" />
                <div v-if="!start" style="height: 70vh"></div>
            </div>
        </b-col>
    </b-row>
</template>

<script>
import VtkViewer from "@/modules/SwxVisualizer/components/VtkViewer";
import VtkGeometry from "@/modules/vtkGeometry/vtkGeometry";
import VtkButton from "@/modules/simulator/components/VtkButton";
import { SOURCE } from "@/modules/julho_14/settings";

export default {
    name: "OutputVisualization",
    components: {
        VtkGeometry,
        VtkButton
    },
    data() {
        return {
            start: false
        };
    },
    computed: {
        vtkFiles() {
            return this.$store.state.julho_14.simulator.vtk_files;
        },
        GeometryUrls() {
            if (this.$store.state.julho_14.simulator.vtk_files === undefined)
                return [];
            return this.$store.state.julho_14.simulator.vtk_files.map(
                ({ name }) => {
                    console.log(name);
                    const splited = name.split(".");
                    return {
                        url: `${window.location.origin}/common/${SOURCE}/simulator/download/?filename=${splited[0]}.vtp`,
                        name: splited[0]
                    };
                }
            );
        },
        downloadHref() {
            return `/common/${SOURCE}/simulator/download/?filename=${this.vtkFiles[0].name}`;
        }
    },
    methods: {
        startVisu() {
            this.start = true;
        }
    }
};
</script>
